import { FilterDialogComponentParams } from './../../components/filters/filters-ui.models';
import { Component, OnInit, Input } from '@angular/core';
import { filterPageTypes, FilterType } from 'src/app/store/filters.era';
import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { JoiEvent } from 'src/app/store/events.era';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { PageHandle } from 'globals/store/permissions.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { TaskToggleMenuComponent } from 'src/app/components/task-toggle-menu/task-toggle-menu.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { TaskListComponent } from 'src/app/components/task-list/task-list.component';

@Component({
    selector: 'app-task-list-page',
    templateUrl: './task-list.page.html',
    styleUrls: ['./task-list.page.scss', '../../page.scss'],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, CommonModule, TopMenuComponent, MobileMenuComponent, IconComponent, TaskToggleMenuComponent, TaskListComponent, MatProgressBarModule],
})
export class TaskListPageComponent extends Wrapper<TaskListPageComponent> implements OnInit {

    @Input() isMyTasks:boolean;
    @Input() page_name: PageHandle = PAGE_NAME.tasks;
    @Input() filterPage: FilterType = filterPageTypes.tasks
    @Input() traceName = traceNames.viewTasksList;
    tasksLoading
    traceNames = traceNames
    eventPreferenceLoading
    showCompleted = true;
    unread = false;
    filter_applied = false;
    
    actualFilterCount: number
    event: JoiEvent
    
    constructor() {
      super()
      this.uiService.changePageTitle("Task List", true)
    }

    ngOnInit() {
      this.subProp(this.store.select('eventPreferences','loading'), 'eventPreferenceLoading')
      this.subProp(this.store.select('tasks', 'loading'), 'tasksLoading')
      this.subProp(this.store.select('filters', this.filterPage, 'count'), 'actualFilterCount')
      this.subProp(this.store.select('events','event'), 'event')
    }

    async filter() {
      const filterGroupings = await this.filtersService.buildTaskPageFilterUI(this.filterPage)
      const params: FilterDialogComponentParams = {width: '380px', autoFocus: false, data: { filterPage: this.filterPage, filterGroupings }}
      this.dialog.open(FiltersDialogComponent, params);
    }

}

